import { AppStore, shouldShowLoadingIndicator } from '@tom-ui/utils'
import { AxiosResponse } from 'axios'

export const onFulfilled = (appStore: AppStore) => {
  return (response: AxiosResponse<any>) => {
    if (
      shouldShowLoadingIndicator(
        window.location.pathname,
        response.config.url
          ? new URL(response.config.url, window.location.origin).pathname
          : undefined,
      )
    ) {
      appStore.decreaseLoadingCounter()
    }

    return response
  }
}

export const onRejected = (appStore: AppStore) => {
  return (error: any) => {
    if (
      shouldShowLoadingIndicator(
        window.location.pathname,
        error.config?.url
          ? new URL(error.config.url, window.location.origin).pathname
          : undefined,
      )
    ) {
      appStore.decreaseLoadingCounter()
    }

    if (error?.response?.status !== 500 && !error?.response?.data?.errors) {
      appStore.setShowAlert(
        'error',
        error?.response?.data?.detail ?? JSON.stringify(error?.message),
      )
    } else if (error?.response?.status === 500) {
      appStore.setShowAlert('error', 'Something went wrong')
    }

    return Promise.reject(error)
  }
}
